var React = require('react');

function FlatArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 0.500244L9.5 9.00024L1 17.5002","stroke":"black"}));
}

FlatArrow.defaultProps = {"width":"11","height":"18","viewBox":"0 0 11 18","fill":"none"};

module.exports = FlatArrow;

FlatArrow.default = FlatArrow;
